import { useEffect } from 'react'
import { usePathname } from 'expo-router'
import { setStatusBarStyle } from 'expo-status-bar'
import { Routes } from '@/src/common/enums/routes'
import { Experiences } from '@/src/experiences'
import { useMenuIsFullWidth } from '@/src/app/main/menu'
import { useColorScheme } from 'react-native'

export function useStatusBarColor() {
  const pathname = usePathname()
  const menuIsFullWidth = useMenuIsFullWidth()
  const colorScheme = useColorScheme()

  useEffect(() => {
    switch (true) {
      case pathname.includes('/main/card/cardBenefits'):
        return setStatusBarStyle('dark', true)
      case pathname.includes('/main/menu'):
        return setStatusBarStyle(menuIsFullWidth ? 'light' : 'dark', true)
      case pathname.includes(Experiences.CardBenefits.Navigation.Routes.Benefit.aliases[0]):
      case pathname.includes(Experiences.Rewards.Navigation.Routes.PointsLedger.route):
      case pathname.includes(Experiences.Rewards.Navigation.Routes.PointsLedger.aliases[0]):
      case pathname.includes(Routes.CardBenefits.route):
      case pathname.includes(Routes.PointsToCashForMortgage.route):
      case pathname.includes('/main/card/'):
      case pathname.includes('/main/points-to-statement-credit'):
      case pathname.includes('/main/rewards/points-transfer'):
      case pathname.includes(Experiences.Notifications.Navigation.Routes.Settings.route):
      case pathname.includes(Experiences.Notifications.Navigation.Routes.Center.route):
      case pathname.includes(Routes.ReferAFriend.route):
      case pathname.includes('/main/storybook') && colorScheme === 'dark':
      case pathname.includes('/main/pii-menu'):
        return setStatusBarStyle('light', true)
      case pathname.includes(Routes.CardOnboarding.route):
      case pathname.includes('/main/storybook'):
      default:
        return setStatusBarStyle('dark', true)
    }
  }, [pathname, menuIsFullWidth, colorScheme])
}
